module.exports = __webpack_public_path__ + "static/UZ_BLOG_230213_ExpertContent_Header-47ec798ace45786e0b8641440f71ea21.webp";